import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, CanActivate, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { take, switchMap, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { SessionService } from 'src/app/store/session/session.service';

@Injectable({
	providedIn: 'root'
})
export class RoleGuard implements CanActivate {
	constructor(private router: Router, private sessionService: SessionService) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.sessionService.getUser().pipe(
			take(1),
			map(user => {
				try {
					const { roles, requiresPaidPlan } = route.data || {};
					const hasRole = roles ? user.hasAnyRole(...roles) : true;

					if (!hasRole) {
						return this.router.createUrlTree(['/']);
					}

					return true;
				} catch (error) {
					console.error(`error checking roleGuard: ${error}`);
					return this.router.createUrlTree(['/']);
				}
			})
		);
	}
}
